export default __webpack_public_path__ + "static/media/avatar_dog1.576f972e.mp3";